import React from 'react';

const ArchiveIcon: React.FC = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.70898 7.54163C9.19232 8.08329 10.809 8.08329 12.2923 7.54163"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0176 1.66663H5.98424C4.20924 1.66663 2.76758 3.11663 2.76758 4.88329V16.625C2.76758 18.125 3.84258 18.7583 5.15924 18.0333L9.22591 15.775C9.65924 15.5333 10.3592 15.5333 10.7842 15.775L14.8509 18.0333C16.1676 18.7666 17.2426 18.1333 17.2426 16.625V4.88329C17.2342 3.11663 15.7926 1.66663 14.0176 1.66663Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0176 1.66663H5.98424C4.20924 1.66663 2.76758 3.11663 2.76758 4.88329V16.625C2.76758 18.125 3.84258 18.7583 5.15924 18.0333L9.22591 15.775C9.65924 15.5333 10.3592 15.5333 10.7842 15.775L14.8509 18.0333C16.1676 18.7666 17.2426 18.1333 17.2426 16.625V4.88329C17.2342 3.11663 15.7926 1.66663 14.0176 1.66663Z"
      stroke="#292D32"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArchiveIcon;
